import { RouterProvider } from 'react-router-dom';
import { router } from './router';

function App() {
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-gold focus:px-4 focus:py-2 focus:font-mono focus:text-xs focus:uppercase focus:tracking-stamp focus:text-night focus:shadow-goldStrong"
      >
        Pular para o conteúdo
      </a>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
